(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BulkMeterDeleteController',BulkMeterDeleteController);

    BulkMeterDeleteController.$inject = ['$uibModalInstance', 'entity', 'BulkMeter'];

    function BulkMeterDeleteController($uibModalInstance, entity, BulkMeter) {
        var vm = this;
        vm.bulkMeter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            BulkMeter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
